import { useMemo } from 'react'
import { gql, useQuery } from '@apollo/client'
import { GetHeroBannersQuery } from '@/types/codegen-federation'
import { HERO_BANNER_FRAGMENT, HeroBannerData, HeroInput, isHeroBannerData } from './types'

const GET_HERO_BANNERS = gql`
  ${HERO_BANNER_FRAGMENT}
  query getHeroBanners {
    heroBanners {
      content {
        id
        banner {
          ...HeroBannerData
        }
      }
    }
  }
`

type RecommendedHeroBannerData = {
  loading: boolean
  refetch: () => void
  heroBanners: HeroBannerData[]
}

export const useRecommendedHeroBanners = (): RecommendedHeroBannerData => {
  const { data, loading, refetch } = useQuery<GetHeroBannersQuery>(GET_HERO_BANNERS, {
    errorPolicy: 'all',
  })

  const heroBanners = useMemo((): HeroBannerData[] => {
    if (!data?.heroBanners?.content?.length) {
      return []
    }

    return data.heroBanners.content
      .map((content): HeroInput => {
        if (content?.banner) {
          return {
            recommendationId: content.id,
            ...content.banner,
          }
        }

        return null
      })
      .filter(isHeroBannerData)
  }, [data])

  return {
    loading,
    heroBanners,
    refetch,
  }
}
